import React from 'react';
import { PropTypes } from 'prop-types';
import cx from 'classnames';

const Tag = ({ className, children, label }) => (
  <span className={cx(className, 'tag')}>{label || children}</span>
);

Tag.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
};

export default Tag;
